import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MerchantAccountType } from '../../models';

@Component({
    selector: 'app-merchant-account-type',
    templateUrl: './merchant-account-type.component.html',
    styleUrls: ['./merchant-account-type.component.css']
})
export class MerchantAccountTypeComponent implements OnInit {

    constructor(
        public activeModal: NgbActiveModal
    ) {
    }

    ngOnInit() {
    }

    chooseDefault() {
        this.activeModal.close(MerchantAccountType.Default);
    }

    chooseCashnet() {
        this.activeModal.close(MerchantAccountType.Cashnet);
    }
}